import { SET_BACKUP_FOLDERS } from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').Backups} Backups
 * @typedef {import('../index').PltrAction} PltrAction
 */

/* Example state:
 * {
 *   folders: [{
 *     backups: ['a-file.pltr'],
 *     path: '/file/path',
 *     date: Date(),
 *   }]
 * }
 */

/**
 * @type {Backups}
 */
const INITIAL_STATE = {
  folders: [],
}

/**
 * @param {Backups} state
 * @param {PltrAction} action
 * @return {Backups}
 */
const backupsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_BACKUP_FOLDERS: {
      return {
        ...state,
        folders: action.folders,
      }
    }
    default: {
      return state
    }
  }
}

export default backupsReducer
